import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatMenu, MatMenuModule, MatMenuTrigger } from '@angular/material/menu'
import { TranslateModule } from '@ngx-translate/core'

export type BalanceChargesResetType =
  | 'template'
  | 'estimate'
  | 'clear'

@Component({
  selector: 'mmx-balance-charges-toolbar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
  ],
  templateUrl: './balance-charges-toolbar.component.html',
})
export class BalanceChargesToolbarComponent {
  @Input() canResetByTemplate = false
  @Input() canResetByEstimate = false
  @Input() templatesEnabled = true
  @Input() templateMenu: MatMenu | null = null
  @Input() canCalculate = false
  @Input() busy = false

  @ViewChild('templateTrigger') templateTrigger?: MatMenuTrigger

  @Output() readonly reset = new EventEmitter<BalanceChargesResetType>()
  @Output() readonly calculate = new EventEmitter<void>()

  onReset(type: BalanceChargesResetType): void {
    this.reset.emit(type)
  }

  onCalculate(): void {
    if (!this.canCalculate || this.busy) return
    this.calculate.emit()
  }

  closeTemplateMenu(): void {
    this.templateTrigger?.closeMenu()
  }
}
